import { reportErrorToNewRelic } from "../helpers/newRelic";
import { getToken } from "../helpers/session";
import httpService from "./HttpService";
import { getGuestAppApiBase, trimTrailingSlashes } from "../helpers/guestApp";

const GUEST_APP_TIMEOUT_MS = 5000;

// URL de la guest app Huésped+ de la empresa, o null ante cualquier error.
export const getGuestAppUrl = companyId => {
  const api = getGuestAppApiBase();
  const base = trimTrailingSlashes(process.env.REACT_APP_GUEST_APP_URL);
  if (!companyId || !api || !base) return Promise.resolve(null);
  return httpService
    .get(
      `${api}/api/v1/public/companies/${encodeURIComponent(
        companyId
      )}/guest-app`,
      { timeout: GUEST_APP_TIMEOUT_MS }
    )
    .then(res => {
      const data = res && res.data;
      if (!data || data.hasGuestApp !== true) return null;
      if (typeof data.slug !== "string" || !data.slug.trim()) return null;
      return `${base}/${encodeURIComponent(data.slug.trim())}`;
    })
    .catch(err => {
      console.warn("No se pudo consultar Huésped+");
      reportErrorToNewRelic("GUEST_APP_API", err);
      return null;
    });
};

// Código de canje de la sesión de Huésped+ (spec 086 de pxsol-blanco): la
// claim_url relativa ("/<slug>/stay/claim/<code>") o null ante cualquier error.
// Sólo se aceptan rutas relativas al host de la guest app.
export const requestGuestAppClaim = () => {
  const api = getGuestAppApiBase();
  const token = getToken();
  if (!api || !token) return Promise.resolve(null);
  // La identidad es el Bearer del huésped (no viaja cid/apellido/empresa).
  // HttpService no lo pone solo a hosts ajenos a api2: se manda explícito.
  return httpService
    .post(
      `${api}/api/v1/stay/claim-codes/from-webcheckin`,
      {},
      {
        timeout: GUEST_APP_TIMEOUT_MS,
        headers: { Authorization: `Bearer ${token}` }
      }
    )
    .then(res => {
      const url = res && res.data && res.data.claim_url;
      if (typeof url !== "string" || url.indexOf("/") !== 0) return null;
      if (url.indexOf("//") === 0) return null;
      return url;
    })
    .catch(err => {
      reportErrorToNewRelic("GUEST_APP_CLAIM", err);
      return null;
    });
};
